import { render } from "./CardConveyor.vue?vue&type=template&id=74ca674e&scoped=true"
import script from "./CardConveyor.vue?vue&type=script&lang=js"
export * from "./CardConveyor.vue?vue&type=script&lang=js"

import "./CardConveyor.vue?vue&type=style&index=0&id=74ca674e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ca674e"]])

export default __exports__